import { Image, Stack, useResponsiveValue } from '@superdispatch/ui';
import { Box, Button, ButtonVariantProp, TextBox } from '@superdispatch/ui-lab';
import { useState } from 'react';
import {
  LoadSuggestionsDrawer,
  SuggestedLoadsSource,
} from '../load-suggestions/LoadSuggestionsDrawer';
import emptyLoadOfferSuggestionsImageDark from './assets/empty-load-suggestions-dark.png';
import emptyLoadOfferSuggestionsImage from './assets/empty-load-suggestions.png';

interface ExploreSuggestedLoadsProps {
  buttonVariant?: ButtonVariantProp;
  source?: SuggestedLoadsSource;
}

export function ExploreSuggestedLoads({
  buttonVariant = 'primary',
  source,
}: ExploreSuggestedLoadsProps) {
  const isMobile = useResponsiveValue(true, false);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Stack space="small" align="center">
        <Image
          width="112px"
          src={emptyLoadOfferSuggestionsImage}
          alt="No Load Offers"
          srcDark={emptyLoadOfferSuggestionsImageDark}
        />
        <Stack space="xsmall" align="center">
          <TextBox variant="heading-3">Explore Suggested Loads</TextBox>
          <Box width="320px">
            <TextBox align="center" color="secondary">
              Smart picks based on your searches and past dispatches, including
              backhauls and along-route loads
            </TextBox>
          </Box>
        </Stack>
        <Button
          variant={buttonVariant}
          size={isMobile ? 'medium' : 'large'}
          onClick={() => {
            setIsOpen(true);
          }}
        >
          View Suggested Loads
        </Button>
      </Stack>

      <LoadSuggestionsDrawer
        open={isOpen}
        source={source}
        onClose={() => {
          setIsOpen(false);
        }}
      />
    </>
  );
}
